import type { FaireProductEntity } from "../../entity_types/product";

export const p_fwd497h: FaireProductEntity = {
  token: "p_fwd497h",
  type: "product",
  name: "Dry Hopped Pear Kombucha",
  brandName: "Fermensch",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d43ebe23f538540457ff3dc6186e0b09d80aa125e15539792ab6fdb3bfccaeb6.webp",
  priceDollars: 6.5,
  description: "Probiotic bubbly tea with dry-hopped pear flavor",
  categoryTokens: ["cat_food-beverages"],
  tags: ["premium", "probiotic", "kombucha", "organic"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/d43ebe23f538540457ff3dc6186e0b09d80aa125e15539792ab6fdb3bfccaeb6.webp",
  weight: 1,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  inStock: true,
};
